import React from "react";
import { StatCard } from "@/components/ui/StatCard";

interface StatisticsCardProps {
  title: string;
  value: string | number;
  description?: string;
  icon: React.ReactNode;
  variant?: "default" | "success" | "warning" | "info" | "danger";
  trend?: { value: number; isPositive: boolean };
  className?: string;
}

const StatisticsCard = ({
  title,
  value,
  description,
  icon,
  variant = "default",
  trend,
  className,
}: StatisticsCardProps) => (
  <StatCard
    title={title}
    value={value}
    description={description}
    icon={React.isValidElement<{ className?: string }>(icon) ? icon : <span>{icon}</span>}
    variant={variant}
    trend={trend ? { value: trend.value, direction: trend.isPositive ? "up" : "down" } : undefined}
    className={className}
  />
);

export default StatisticsCard;
